

export const ENV = () => ({
  CMN_PDF_QUALITY: Number(process.env.REACT_APP_CMN_PDF_QUALITY || 80),
});
